








































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import moment from 'moment'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage, onlyNumber } from '@/utils/common'
import { AgrupamentoRepasse, ModoMoverItemAgrupamento, montarMoverItemAgrupamentoRequest, MoverItemAgrupamentoResponse } from '@/types/interfaces/MoverItemAgrupamento'

@Component
export default class ModalMoverItemAgrupamento extends Vue {
  @Prop({ required: true, default: false }) visible: boolean
  @Prop({ default: null }) item: AgrupamentoRepasse | null
  @Prop({ default: '' }) agrupamentoOrigemId: string
  @Prop({ default: '' }) fontePagadoraId: string
  @Prop({ default: null }) anoMesReferencia: string | null
  @Prop({ default: null }) repassesQueSolicitamNF: boolean | null

  onlyNumber = onlyNumber

  modo: ModoMoverItemAgrupamento = 'novo'
  numeroChamadoNovo = ''
  agrupamentoDestinoId: string | null = null
  agrupamentosElegiveis: any[] = []
  destinosCarregados = false
  carregandoDestinos = false
  movendo = false

  get podeConfirmar() {
    if (this.modo === 'novo') return !!this.numeroChamadoNovo
    return !!this.agrupamentoDestinoId
  }

  @Watch('visible')
  async onVisibleChange(novoValor: boolean) {
    if (!novoValor) return

    this.modo = 'novo'
    this.numeroChamadoNovo = ''
    this.agrupamentoDestinoId = null
    this.agrupamentosElegiveis = []
    this.destinosCarregados = false
  }

  @Watch('modo')
  async onModoChange(modo: string) {
    if (modo === 'existente' && !this.destinosCarregados) await this.carregarAgrupamentosElegiveis()
  }

  async carregarAgrupamentosElegiveis() {
    this.carregandoDestinos = true
    try {
      const params: any = {
        fontePagadoraId: this.fontePagadoraId,
        pagina: 1,
        qtdPorPagina: 200,
      }
      if (this.anoMesReferencia) params.anoMesReferencia = moment(this.anoMesReferencia).format('YYYY-MM-DD[T]HH:mm:ss')
      if (this.repassesQueSolicitamNF !== null) params.repassesQueSolicitamNF = this.repassesQueSolicitamNF

      const response: any = await RemuneracaoMedicaApi.getAgrupamentos(params)
      if (!response.success) {
        this.agrupamentosElegiveis = []
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Não foi possível carregar os agrupamentos de destino.', 'error'))
        return
      }

      this.destinosCarregados = true
      this.agrupamentosElegiveis = (response.data.itens || [])
        .filter((agrupamento: any) => agrupamento.id !== this.agrupamentoOrigemId)
        .map((agrupamento: any) => ({
          id: agrupamento.id,
          label: `${agrupamento.numeroChamado || 'sem chamado'} (${agrupamento.quantidadeRepasses} repasse(s))`,
        }))
    } finally {
      this.carregandoDestinos = false
    }
  }

  async confirmar() {
    this.movendo = true
    try {
      if (!this.item) return

      const params = montarMoverItemAgrupamentoRequest(this.modo, this.item.prestadorRecebimentoDocumentoId, this.numeroChamadoNovo, this.agrupamentoDestinoId)

      const response = await RemuneracaoMedicaApi.moverItemAgrupamento(params)

      if (!response.success) {
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Não foi possível mover o item.', 'error'))
        return
      }

      EventBus.$emit('setSnackbar', getSnackbarMessage(this.montarMensagemSucesso(response.data), 'success'))
      this.moved()
      this.close()
    } finally {
      this.movendo = false
    }
  }

  montarMensagemSucesso(resposta?: MoverItemAgrupamentoResponse) {
    const mensagem = 'Repasse movido com sucesso.'
    if (!resposta || !resposta.aviso) return mensagem

    return `${mensagem} Atenção: ${resposta.aviso}`
  }

  @Emit('moved')
  moved() { }

  @Emit('close')
  close() { }
}
